

































import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import SolutionsReagents from './SolutionsReagents.vue'
import Formulation from './Formulation.vue'
import Storage from './Storage.vue'

export default defineComponent({
  components: {
    SolutionsReagents,
    Formulation,
    Storage,
  },
  props: {
    dilutions: {
      type: Array as () => Array<{
        application: string
        dilution: string
      }>,
      required: false,
      default: undefined,
    },
    directionsForUse: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    solutionsReagents: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    formulation: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    productStorage: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    eclipMessage: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const displayCondition =
      !isEmpty(props.dilutions) ||
      props.productStorage ||
      props.directionsForUse ||
      props.formulation ||
      props.solutionsReagents

    return { displayCondition, isEmpty }
  },
})
